module.exports = __webpack_public_path__ + "assets/images/Sync1.2bb065f8.jpg";